import { useState, useEffect, memo } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text,
  Button,
  useColorModeValue,
  MenuButtonProps,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useSession } from "next-auth/client";
import { getAccount } from "utils/sessionHelper";

interface Props {
  placeholder?: string;
  onSelectList: (list: any) => void;
  reset?: boolean;
  isDisabled?: boolean;
  menuButtonProps?: MenuButtonProps;
  value?: any;
  filterListIds?: number[];
}

export function ContactListDropdown({
  placeholder = "Contact lists",
  onSelectList,
  reset = false,
  isDisabled = false,
  menuButtonProps = {},
  value = undefined,
  filterListIds = []
}: Props) {
  const [selectedList, setSelectedList] = useState<any>();
  const [session] = useSession();
  const downIconColor = useColorModeValue("gray.400", "gray.500");
  const textColor = useColorModeValue("gray.400", "gray.500");
  let contactLists = getAccount(session)?.contactLists || [];
  contactLists = contactLists.filter(c => !(c.isSubscribers || c.isSupporters));

  if (filterListIds?.length > 0) {
    contactLists = contactLists?.filter(l => !filterListIds.includes(l.id))
  }

  useEffect(() => {
    if (reset) {
      setSelectedList(null);
    }
  }, [reset]);

  useEffect(() => {
    if (value !== undefined || value !== null) {
      setSelectedList(value);
    }
  }, [value])

  if (!session) {
    return null;
  }

  return (
    <Menu isLazy>
      <MenuButton
        as={Button}
        // size="sm"
        variant={"secondary"}
        rightIcon={<ChevronDownIcon color={downIconColor} />}
        ml="2"
        isDisabled={isDisabled}
        {...menuButtonProps}
      >
        {selectedList?.name ? (
          <Text maxW="200px" noOfLines={1} wordBreak="break-all">
            {selectedList.name}
          </Text>
        ) : (
          <Text maxW="200px" color={textColor} noOfLines={1} wordBreak="break-all">
            {placeholder}
          </Text>
        )}
      </MenuButton>
      <MenuList maxH="215px" overflow="scroll">
        {contactLists?.length > 0 ? (
          contactLists?.map((l) => (
            <MenuItem
              key={l.id}
              onClick={() => {
                setSelectedList(l);
                onSelectList(l);
              }}
            >
              {l.name}
            </MenuItem>
          ))
        ) : (
          <MenuItem>No List found</MenuItem>
        )}
      </MenuList>
    </Menu>
  );
}

export const ContactListDropdownMemoed = memo(ContactListDropdown);
